import TutorialArrow from "../TutorialArrow";
import { StyledTutorialAchievementArea, StyledTutorialLargeText, StyledTutorialTitle } from "./TutorialModal.styled";

export const AchievementUnlocked = ({ earnings, title, textBefore, textLines, textAfter, arrowSelector, mediaItems }) => {
  const items = earnings?.items || [];
  const xp = earnings?.xp || 0;
  const points = earnings?.points || 0;
  const shopUnlocks = earnings?.shop_unlocks || '';
  const mainText = earnings ? getItemsText(items, xp, points) : '';

  return (<>
    <StyledTutorialAchievementArea>
      {items.map((asset) => (
        <div className="media-item"><img src={asset.getImgSource()} /></div>
      ))}
      {xp > 0 && <div className="media-item">
          <img className="img-contain" src='/assets/points.svg' />
          <div className="media-factor">{xp}</div>
        </div>
      }
      {points > 0 && <div className="media-item">
          <img className="img-contain" src='/assets/coin_low.gif' />
          <div className="media-factor">{points}</div>
        </div>
      }
      {shopUnlocks && <div className="media-item">
          <img className="img-contain" src='/assets/shop_unlocks.svg' />
          <div className="media-factor">{getShopLevel(shopUnlocks)}</div>
        </div>
      }
      {mediaItems?.length > 0 && mediaItems.map(item => (<div className={`media-item ${(item.className || '')}`}>
          <img className="img-contain" src={item.image_url} />
      </div>
      ))}
    </StyledTutorialAchievementArea>
    <StyledTutorialTitle $align="center">{ title || 'ACHIEVEMENT UNLOCKED' }</StyledTutorialTitle>
    <StyledTutorialLargeText>
      {textLines?.length && textLines.map((line, idx) => <><span>{line}</span><br /></>  )}
      {textBefore && <span>{textBefore}<br /></span>}
      {mainText}
      {textAfter && <span><br />{textAfter}</span>}
    </StyledTutorialLargeText>
    { arrowSelector && <TutorialArrow selector={arrowSelector}/>}
  </>)
}

function getItemsText(items, xp, points) {
  const assetNames = items.map(asset => asset.getName());
  const unlockeItems = assetNames.slice();
  if (xp) {
    unlockeItems.push(`${xp} XP`);
  }
  if (points) {
    unlockeItems.push(`${points} ${points > 1 ? 'BONES' : ' BONE'}`);
  }
  if (unlockeItems.length > 1) {
    for (let i = unlockeItems.length - 1; i > 0; i--) {
      const prefix = (i === (unlockeItems.length - 1)) ? ' and ' : ', ';
      unlockeItems[i] = prefix + unlockeItems[i];
    }
  }
  return unlockeItems.join('');
}

function getShopLevel(rarity) {
  const levelsMapping = {
    'base':1,
    'common':2,
    'uncommon':3,
    'rare': 4,
    'super_rare': 5,
    'legendary': 6,
  }
  return levelsMapping[rarity] || 1;
}